import createSvgIcon from '../../Utils/CreateSvgIcon';

export const Cascades = createSvgIcon(
  <>
    <path
      d="M21.2857 7L11 7V10.6L21.2857 10.6V7Z"
      transform="translate(-8 -4)"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.92857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.4 14.2002L15.1143 14.2002V17.8002H25.4V14.2002Z"
      transform="translate(-8 -4)"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.92857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.2571 21.4004H18.9714V25.0004H29.2571V21.4004Z"
      transform="translate(-8 -4)"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.92857"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  'Cascades',
);
